import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCartIcon, MenuIcon, XIcon, SearchIcon } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="sticky top-0 z-50 bg-white shadow-sm" data-id="element-75">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between" data-id="element-76">
        <Link to="/" className="flex items-center" data-id="element-77">
          <span className="text-2xl font-bold" data-id="element-78">
            <span className="text-green-500" data-id="element-79">Tech</span>
            <span className="text-amber-500" data-id="element-80">Gold</span>
          </span>
        </Link>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-81">
          <Link to="/" className="text-gray-700 hover:text-green-500 transition-colors" data-id="element-82">
            Home
          </Link>
          <Link to="/shop" className="text-gray-700 hover:text-green-500 transition-colors" data-id="element-83">
            Shop
          </Link>
          <Link to="/about" className="text-gray-700 hover:text-green-500 transition-colors" data-id="element-84">
            About
          </Link>
          <Link to="/contact" className="text-gray-700 hover:text-green-500 transition-colors" data-id="element-85">
            Contact
          </Link>
        </nav>
        <div className="flex items-center space-x-4" data-id="element-86">
          <button className="hidden md:block text-gray-700 hover:text-green-500 transition-colors" data-id="element-87">
            <SearchIcon size={20} data-id="element-88" />
          </button>
          <Link to="/cart" className="relative text-gray-700 hover:text-green-500 transition-colors" data-id="element-89">
            <ShoppingCartIcon size={20} data-id="element-90" />
            <span className="absolute -top-2 -right-2 bg-green-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center" data-id="element-91">
              0
            </span>
          </Link>
          <button className="md:hidden text-gray-700" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-92">
            <MenuIcon size={24} data-id="element-93" />
          </button>
        </div>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden fixed inset-0 bg-white z-50 p-4" data-id="element-94">
          <div className="flex justify-end" data-id="element-95">
            <button onClick={() => setIsMenuOpen(false)} data-id="element-96">
              <XIcon size={24} data-id="element-97" />
            </button>
          </div>
          <nav className="flex flex-col items-center space-y-6 mt-16" data-id="element-98">
            <Link to="/" className="text-xl text-gray-700 hover:text-green-500 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-99">
              Home
            </Link>
            <Link to="/shop" className="text-xl text-gray-700 hover:text-green-500 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-100">
              Shop
            </Link>
            <Link to="/about" className="text-xl text-gray-700 hover:text-green-500 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-101">
              About
            </Link>
            <Link to="/contact" className="text-xl text-gray-700 hover:text-green-500 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-102">
              Contact
            </Link>
          </nav>
        </div>}
    </header>;
};